import { BooleanColumn, StringColumn } from 'baseui/data-table';
import { CustomDateColumn } from 'commons-ui';
import { IPaymentNotificationTemplate } from '../../utils/constants';

export const COL_NAMES = {
	notificationType: 'notificationType',
	merchantName: 'merchantName',
	userText: 'userText',
	isActive: 'isActive',
	delink: 'delink',
	isPGError: 'isPGError',
	instantFailure: 'instantFailure',
	title: 'title',
	pgText: 'pgText',
	smsMessage: 'smsMessage',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	userFailureMessage: 'userFailureMessage'
};

export const columnConfigs = [
	StringColumn({
		title: 'Notification Type',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.notificationType] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Merchant Name',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.merchantName] || '',
		maxWidth: 200
	}),
	BooleanColumn({
		title: 'isActive',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.isActive] || true,
		maxWidth: 200
	}),
	StringColumn({
		title: 'User Text',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.userText] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'User Failure Message',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.userFailureMessage] || '',
		maxWidth: 200
	}),
	BooleanColumn({
		title: 'Delink',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.delink] || false,
		maxWidth: 200
	}),
	BooleanColumn({
		title: 'Is PG Error',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.isPGError] || false,
		maxWidth: 200
	}),
	BooleanColumn({
		title: 'Instant Failure',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.instantFailure] || false,
		maxWidth: 200
	}),
	StringColumn({
		title: 'Title',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.title] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'PG Text',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.pgText] || ''
	}),
	StringColumn({
		title: 'SMS Message',
		mapDataToValue: (data: IPaymentNotificationTemplate) => data[COL_NAMES.smsMessage] || '',
		maxWidth: 200
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	}),
	CustomDateColumn({
		title: 'Updated At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.updatedAt
	})
];
